import { Component } from "react";

import "./style.scss";

class SearchInput extends Component {
    render() {
        return (
            <>
                <div className="search-input">
                    <input type="search" name="search" onChange={this.props.onChange} />
                </div>
            </>
        )
    }
}

export default SearchInput;